module.exports = __webpack_public_path__ + "img/expand-window.87c0b5eb.gif";